import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { Accordion, Badge } from '@morressier/alembic';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IGetReviewsSummaryResponse } from '@publishing-engine/submission-service/src/endpoints/api.response-types';
import FileViewerButtonText from '../FileViewerButtonText';

interface ReviewSummaryAccordionProps {
  reviews: IGetReviewsSummaryResponse;
  submissionId?: string;
}

const renderItem = (
  review: IGetReviewsSummaryResponse[number],
  submissionId: string | undefined
) => {
  const { attachments, comment } = review;

  return (
    <Flex flexDirection="column" gap={6} padding={2}>
      <Box>
        <Badge>Reviewer Comments</Badge>
      </Box>
      <Box>
        <Text textStyle="headingItem">Feedback for Authors</Text>
        <Text textStyle="textBody">{comment}</Text>
      </Box>

      {!!attachments?.length && (
        <Box marginTop={2}>
          <Text textStyle="headingItem">Reviewer Attachments</Text>
          <Flex flexDirection="column" marginTop={2} gap={2}>
            {(attachments ?? []).map(attachment => (
              <Flex
                justifyContent="space-between"
                key={attachment.referenceName}
              >
                <Flex gap={2} alignItems="center">
                  <FontAwesomeIcon icon={faFile} />
                  <Text textStyle="textBody">{attachment.referenceName}</Text>
                   <FileViewerButtonText
                    file={attachment}
                    submissionContextId={submissionId}
                    textStyle="textBody"
                    flexShrink={0}
                  >
                    View
                  </FileViewerButtonText>
                </Flex>
              </Flex>
            ))}
          </Flex>
        </Box>
      )}
    </Flex>
  );
};

const ReviewSummaryAccordion: React.FC<ReviewSummaryAccordionProps> = ({
  reviews,
  submissionId
}) => {
  return (
    <Accordion
      accordionItemProps={{
        marginBottom: 0,
        borderTop: '1px',
        borderColor: 'neutralPrimaryBorder',
        _first: {
          borderColor: 'none',
          borderTop: '0'
        }
      }}
      items={reviews
        .filter(review => !!review.referenceAssessmentId)
        .map((review, index) => ({
          title: `Reviewer ${index + 1} Feedback`,
          content: renderItem(review, submissionId)
        }))}
    />
  );
};

export default ReviewSummaryAccordion;
